import script from "./ChatSidebarGlobalNav.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSidebarGlobalNav.vue?vue&type=script&setup=true&lang=js"

import "./ChatSidebarGlobalNav.vue?vue&type=style&index=0&id=e89d9f40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e89d9f40"]])

export default __exports__